import { render } from "./container-messages.vue?vue&type=template&id=6c5ebc7d"
import script from "./container-messages.vue?vue&type=script&lang=js"
export * from "./container-messages.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__